import React from 'react';
import S from './ColorOption.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const options = [{
  value: '#000000',
  name: 'Black'
}, {
  value: '#67798E',
  name: 'Gray'
}, {
  value: '#583536',
  name: 'Brown'
}, {
  value: '#d43537',
  name: 'Red'
}, {
  value: '#e5852f',
  name: 'Orange'
}, {
  value: '#ffe146',
  name: 'Yellow'
}, {
  value: '#6eb047',
  name: 'Light Green'
}, {
  value: '#5c8543',
  name: 'Dark Green'
}, {
  value: '#91bdfe',
  name: 'Light Blue'
}, {
  value: '#1650a5',
  name: 'Dark Blue'
}, {
  value: '#ffffff',
  name: 'White'
}];
export default function ColorOption(props) {
  const {
    option,
    selected,
    onClick,
    ...rest
  } = props;
  const name = options.find(opt => opt.value === option.value)?.name;
  const style = {
    border: selected ? '1px solid black' : undefined,
    ...rest.style
  };
  return /*#__PURE__*/_jsx("div", {
    title: name,
    onClick: () => {
      if (typeof onClick === 'function') {
        onClick({
          data: option
        });
      }
    },
    className: S.colorOption,
    style: style,
    children: /*#__PURE__*/_jsx("div", {
      className: S.optionRing,
      children: /*#__PURE__*/_jsx("div", {
        className: S.innerOption,
        style: {
          backgroundColor: option?.value
        }
      })
    })
  });
}